<template>
  <div class="salesmanmymemberviplistPage">
        <XR-edit-head :titleText="saleMenCategory?saleMenCategory[1]:'创客'" :rightButtonText="buttonText" :rightButtonShow="editButtonShow" ref="head" @editEvent="editEvent" @completeEvent="completeEvent" ></XR-edit-head> 
      <div :style="'margin-bottom:'+ height + 'px'">
	  <mu-list> 
        <mu-list-item  class="list" v-for="mItem in memberList.List" :key="mItem.minnerbm">
          <div class="mu-item-title">
              <mu-checkbox class="cart-chk" :nativeValue="mItem.userbm" v-model="checkList" uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-check-circle" slot="left" v-if="mode=='edit'" />    
              <div class="dd3">
                <img :src="mItem.headPic" alt="">
              </div>
              <div class="dd1">
                <p>{{mItem.userbm}}</p>
                <p class="telephone">{{mItem.mobile}}</p>     
                <p class="number">{{mItem.reallyname}}</p>                
              </div>
              <div class="dd2">
                <p>{{mItem.zcpvname}}</p>
                <p>{{mItem.IsBuHuo?'未补货':''}}</p>
                <p class="date">{{mItem.shsjname}}</p>
              </div>
            </div>
        </mu-list-item>
     </mu-list>
     </div>
	 
      <div class="bottom-bar" v-if="mode =='edit'">
          <mu-row >
          <mu-col width="100" tablet="100" desktop="100">        
              <mu-checkbox v-model="isChkAll" label="全选" uncheckIcon=":fa fa-circle-thin" checkedIcon=":fa fa-check-circle" @change="chkAll()" class="cart-all-chk"/>

              <mu-raised-button class="operatorBtn" @click="buhuo()" label="补货" />
          </mu-col>
          </mu-row>
      </div>
      
      <mu-dialog :open="dialog" @close="close" title="补货方式" scrollable>
        <mu-menu>
          <mu-menu-item title="自提" @click="alreadyGetGift" />
          <mu-menu-item title="物流" @click="goToBuHuo"/>
        </mu-menu>
        <mu-flat-button primary label="关闭" @click="close" slot="actions"/>
      </mu-dialog>

      <XR-toast @onClose="getMemberList" ref="XRtoast"></XR-toast>
      <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>
<script>
export default {
  data () {
    return {
    titleIcon : 'fa fa-angle-down',
    buttonText:'管理',
    topPopup: false,
      searchInfo:{
        pageIndex:1,
        pageSize:1000,
        zcpv:0,
        shbs:1,
        startdate:'',
        enddate:'',
        e:1
      },
      memberList:{},
     
      mode: this.$route.query.mode?this.$route.query.mode:'normal', //如果mode=normal，则代表正常，如果mode=select，则代表选择模式，选中即跳转回去
      editButtonShow: this.$route.query.mode == 'select' ?false:true,
      checkList:[],
      isChkAll: false,
      checkAllList:[],
      dialog : false,
	  height:0,
	  saleMenCategory:window.localStorage.saleMenCategory.split(",")
    }
  },
  mounted(){
    //  this.$refs.XRtoast.load('加载中...')
    this.getMemberList()
    this.GetBuHuoConfig()
  },
  methods: {
    GoHistory(){
      this.$router.goBack()
    },
    GetBuHuoConfig(){
      var ths = this;
      ths.$post("/Salesman/SalesmanServer/GetBuHuoConfig")
        .then(function (res) {
          if(!res.IsSuccess){
            ths.editButtonShow =  false
          } else{
            ths.editButtonShow = true
          }
        })
    },
    getMemberList(){           
      const ths = this;
      ths.$post("/Salesman/SalesmanServer/GetMyShopMemberStream", this.searchInfo)
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false;
          ths.memberList = res.Data
          for(var i = 0; i< ths.memberList.List.length;i++){
            ths.checkAllList.push(ths.memberList.List[i].userbm)
          }
          ths.$refs.XRPageTip.initTip()

          ths.$refs.XRtoast.hide();
        }
        else{
          ths.editButtonShow = false
          ths.memberList = {}
          ths.checkAllList=[]
          ths.$refs.XRPageTip.ShowEmpty('暂无数据')
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    
    editEvent: function(){
      this.mode='edit';
	  this.height=56;
    }, 
    completeEvent: function(){
      this.mode='normal';
	  this.height=0;
    },
    chkAll: function(){
      if(!this.isChkAll){
        this.checkList = this.checkAllList
      }else {
        this.checkList = []
      }
    },
    buhuo(){
      this.open()
    },
    open () {
      if(this.checkList.length ==0){
        this.$refs.XRtoast.failed('请选择要补货的会员', true);
        return
      }

      for(var i = 0; i< this.memberList.List.length; i++){
        for(var j = 0; j< this.checkList.length;j++){
          var memberItem = this.memberList.List[i];
          var checkItem = this.checkList[j];
          if(memberItem.userbm == checkItem){
            if(!memberItem.IsBuHuo){
              this.$refs.XRtoast.failed(memberItem.userbm+'会员已补货', true);
              return
            }
          }
        }
      }

      this.dialog = true
    },
    close () {
      this.dialog = false
    },
    alreadyGetGift(){    
      this.close()
      var ths = this
      var userNames = []
      for(var i = 0;i<this.checkList.length;i++){
        userNames.push(this.checkList[i])
      }
      ths.$post(
        "/Salesman/SalesmanServer/HelpAllreadyGetGift", {userNameList: userNames}
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          ths.checkList=[]
          ths.$refs.XRtoast.success(res.Msg, true)
        }
      });
    },
    goToBuHuo(){
      
      this.close()
      var userNames = []
      for(var i = 0;i<this.checkList.length;i++){
        userNames.push(this.checkList[i])
      }

      this.$router.push('/salesman/helpGiftAddress?userNameList='+ userNames.join(','))
    }
  }
}
</script>
<style>
      .salesmanmymemberviplistPage.child-view{
        background: #fff;
      }
      .salesmanmymemberviplistPage .mu-list{
        
      }
      .salesmanmymemberviplistPage .mu-appbar .mu-appbar-title{
        font-size: 16px;
      }
      .salesmanmymemberviplistPage .list .mu-item{
          border-bottom: 1px solid #f5f5f5;
        }
      .salesmanmymemberviplistPage .mu-list .list:last-child .mu-item{
          border-bottom: 0;
        }
      .salesmanmymemberviplistPage .dd1{
            float:left;
            width: 50%;
            padding-left: 5%;
            text-align:left;
        }
      .salesmanmymemberviplistPage .dd1,.salesmanmymemberviplistPage .dd2 {
        font-size: 12px;
        }
      .salesmanmymemberviplistPage .dd1 .number{
        color: #999;
        }
      .salesmanmymemberviplistPage .mu-list .mu-checkbox{
        float: left;
        width: 10%;
        margin-top: 5px;
      }
      .salesmanmymemberviplistPage .mu-checkbox .mu-checkbox-icon-uncheck, .salesmanmymemberviplistPage .mu-checkbox-icon-checked {
        font-size: 18px;
        margin-top: 3px;   
      }
      .salesmanmymemberviplistPage .dd2 .date {  font-size:12px;color: #999;}
      .salesmanmymemberviplistPage .dd2{
          float:left;
          width:30%;
          text-align:right;
      }
      .salesmanmymemberviplistPage .dd3
        {
            float:left;
            width:10%;
            text-align:center;

        }
        .salesmanmymemberviplistPage .dd3 img{
          width: 35px;
          height: 35px;
          border-radius: 50%;
          object-fit: cover;
        }

       .salesmanmymemberviplistPage .dd3 .btn
        {
          background-color: #e2000e;
          color: #fff;
          display: block;
          width: 60px;
          height: 18px;
          font-size: 12px;
          margin-top: 9px;
          margin-left: 10%;
          float: right;
        }
       .salesmanmymemberviplistPage .mu-raised-button{
          min-width: 0px;
        }
       .salesmanmymemberviplistPage .dd3 a.huihui
        {
            font-size:12px;
            background:#999;
            cursor:inherit;
        }


      .salesmanmymemberviplistPage .bottom-bar{
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: white;
        height: 56px;
        border-top:1px solid #eee;
      }
      .salesmanmymemberviplistPage ,.bottom-bar .mu-checkbox-icon{
        margin-right: 0px; 
      }
      .salesmanmymemberviplistPage .bottom-bar .cart-all-chk{
        float: left;
        height: 24px;
        margin: 16px 0 16px 5%;
      }
      .salesmanmymemberviplistPage .bottom-bar .operatorBtn{
        float: left;
        height: 56px;
        font-size: 12px;
        float: right;
        background: red;
        color: #fff;
        width: 25%;
      }
      .salesmanmymemberviplistPage .bottom-bar .mu-checkbox.label-left .mu-checkbox-icon {
        margin-top: 5px;
    }
      .salesmanmymemberviplistPage .bottom-bar .mu-flat-button-wrapper{
      
      }
</style>


// WEBPACK FOOTER //
// src/pages/salesman/mymemberviplist.vue